// extracted by mini-css-extract-plugin
module.exports = {"background":"TestimonialsSection_background__VFFtw"};